mutation RequestMyPasswordReset {
  reset: StreamToolsRequestMyPasswordReset {
    sent
  }
}
